export default __webpack_public_path__ + "static/media/qurifano-veterinario.dad6ff1f.jpg";